import React, { useState, useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import "./App.css";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { theme } from "./Components/ThemeProvider/ThemeProvider";
import Router from "./routes";
import Footer from "./Components/Footer/Footer";
import BackToTopButton from "./Components/BacktoTop/BackToTopComp";
import HeaderComp from "./Components/HeaderComp/HeaderComp";
import FooterComp from "./Components/FooterComp/FooterComp";
import { useSelector } from "react-redux";

function App() {
  const pathName = useSelector((state: any) => state.PATHNAME.pathname);

  console.log("pathName", pathName);
  return (
    <ThemeProvider theme={theme}>
      <HeaderComp />

      <BrowserRouter>
        <Router />
      </BrowserRouter>
      {/* {pathName === "/" && (
        <div className="mobileFooter">
          <FooterComp />
        </div>
      )} */}
      {pathName === "/" &&
      <div className="webFooter">
        <FooterComp />
      </div> }

      <BackToTopButton />
    </ThemeProvider>
  );
}

export default App;
